import styled from 'styled-components';

export const Wrapper = styled.section<any>`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #2dafef;
  background-image: url(${props => props.background});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export const InnerWrapper = styled.div`
  max-width: 1360px;
  padding: 7% 16px 0;
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 248px);
`;

export const Header = styled.h2`
  margin: 80px 0 41px;
  width: 100%;
  font-family: "Causten Black";
  font-size: 75px;
  font-weight: 400;
  line-height: 0.92;
  text-align: center;
  color: #fff;
  
  @media(min-width: 880px) {
    margin: 0 0 41px;
  }
`;

export const ContactDataWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: auto 0;
  justify-content: space-evenly;
  flex-wrap: wrap;

  @media(max-width: 880px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Footer = styled.footer`
  width: 100%;
  min-height: 178px;
  margin-top: 250px;
  background-color: #fff;
  margin: auto 0 0;

  @media(max-width: 880px) {
    margin-top: 300px;
  }
`;

export const FooterBody = styled.div`
  box-sizing: border-box;
  max-width: 1420px;
  padding: 50px 16px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
`;

export const CopyRight = styled.p`
  font-family:"Causten Regular";
  font-weight: 400;
  font-size: 19px;
  text-align: center;
  margin: 0;
  width: 365px;
  color: #707070;
`;

export const ItemWrapper = styled.div`
  display: flex;
  min-width: 182px;
  margin-bottom: 18px;

  @media(max-width: 880px) {
    min-width: 100%;
    padding-left: 30%;
  }

  @media(max-width: 400px) {
    padding-left: 20px;
  }
`;

export const ItemIcon = styled.img`
  width: 26px;
  height: 26px;
  margin-right: 13px;
  color: #2dafef;
`;

export const ItemBody = styled.a`
  text-decoration: none;
`;

export const ItemHeader = styled.h6`
  font-family:"Causten Regular";
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0;
`;

export const ItemText = styled.p`
  margin: 12px 0 0;
  font-family:"Causten Regular";
  font-size: 18px;
  color: #fff;
`;

export const EuropeFunds = styled.img`
  object-fit: contain;
`;

export const FoundsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 2;
`;
